export const ACCESS_TOKEN = 'Access-Token'
export const DEFAULT_COLOR = 'Default_Color'
export const ACCOUNT_TYPE = 'Account_Type'
export const DEFAULT_CONTENT_WIDTH_TYPE = 'Default_Content_Width_Type'
export const REGION = 'Region'
